import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BallotIcon(props: IconProps) {
    return <Icon {...props} iconKey={"ballot"}/>
}
